import React, { useEffect, useState } from "react";
import { Row, Col, Transfer, Button, Popover } from "antd";
import { isEmpty } from "lodash";
import UserInfoCard from "../UserInfoCard/UserInfoCard";
import UserSelect from "../UserSelect/UserSelect";

const styles = {
  transfer: {
    // marginLeft: "24px",
    height: "60vh",
  },
  transferList: {
    height: "60vh",
    width: "100%",
  },
};

export default function AdministrationRoles(props) {
  const { selectedUser, handleSelectUser, handleAssignRolesToUser, users, roles } = props;

  const [transferData, setTransferData] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);
  const [isDisabledButton, setIsDisabledButton] = useState(true);

  useEffect(() => {
    setTransferData(
      roles.map((role) => ({
        key: role.id,
        id: role.id,
        alias: role.alias,
        dsc: role.dsc,
      }))
    );
  }, [roles]);

  useEffect(() => {
    if (selectedUser) {
      setTargetKeys(selectedUser.includedRoles.map((item) => item.id));
    }
  }, [selectedUser]);

  const handleChange = (nextTargetKeys) => {
    setTargetKeys([...nextTargetKeys]);
    setIsDisabledButton(false);
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <UserSelect users={users} handleChangeUser={handleSelectUser} />
          {!isEmpty(selectedUser) && <UserInfoCard user={selectedUser} />}
        </Col>
        <Col flex="1">
          <Transfer
            dataSource={transferData}
            targetKeys={targetKeys}
            onChange={handleChange}
            titles={["Доступные роли", "Назначенные роли"]}
            render={(item) => <Popover content={item.dsc}>{item.alias}</Popover>}
            showSearch
            filterOption={(inputValue, item) =>
              item.alias.toLowerCase().includes(inputValue.toLowerCase()) ||
              item.dsc.toLowerCase().includes(inputValue.toLowerCase())
            }
            style={styles.transfer}
            listStyle={styles.transferList}
            disabled={isEmpty(selectedUser)}
          />
        </Col>
      </Row>
      <Row className="row_buttons" justify="end">
        <Button
          type="primary"
          onClick={() => {
            handleAssignRolesToUser(targetKeys);
            setIsDisabledButton(true);
          }}
          htmlType="button"
          disabled={isDisabledButton}
        >
          Применить
        </Button>
      </Row>
    </>
  );
}
